const { fetchWithRetry } = require('./utils'); // Import fetchWithRetry  

// Function to create a new venue  
const createVenue = async (venueData) => {
    try {
        const response = await fetchWithRetry('/api/venues', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(venueData),
        });

        if (!response.ok) {
            throw new Error(`Error creating venue: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating venue:', error);
        throw error;
    }
};

// Function to get all venues  
const getVenues = async () => {
    try {
        const response = await fetchWithRetry('/api/venues', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching venues: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching venues:', error);
        throw error;
    }
};

// Function to update a venue  
const updateVenue = async (venueId, venueData) => {
    try {
        const response = await fetchWithRetry(`/api/venues/${venueId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(venueData),
        });

        if (!response.ok) {
            throw new Error(`Error updating venue: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating venue:', error);
        throw error;
    }
};

// Function to delete a venue  
const deleteVenue = async (venueId) => {
    try {
        const response = await fetchWithRetry(`/api/venues/${venueId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting venue: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting venue:', error);
        throw error;
    }
};

// Function to get a venue by ID  
const getVenueById = async (venueId) => {
    try {
        const response = await fetchWithRetry(`/api/venues/${venueId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching venue: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching venue:', error);
        throw error;
    }
};

module.exports = {
    createVenue,
    getVenues,
    updateVenue,
    deleteVenue,
    getVenueById,
};  